import type React from 'react'
import { cn } from '../../../../shared/cn'
import { applyPolishOrphans } from '../../../../shared/preventPolishOrphans'

export function P3({ className, children, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p
      {...props}
      className={cn('text-contentSecondary text-sm leading-6 xl:text-base xl:leading-7', className)}
    >
      {applyPolishOrphans(children)}
    </p>
  )
}
